<template>
    <div class="flowChartList">
        <template v-for="(item,index) in dynamicData">
            <div class="procedureList" :class="{'countersignatureNode': item.node_type ==3}" :key="index">
                <h3 class="countersignatureTitle" v-if="item.node_type ==3">
                    <i class="iconfont icon05qunzufill"></i>
                    会签审核
                </h3>
                <template v-for="(k, i) in item.data">
                    <div class="listBox" :key="i">
                        <h4>{{ k.Content }}</h4>
                        <div class="userInfo">
                            <span class="headPortrait">
                                <img src="./images/head_portrait2.png" alt="头像">
                                <i class="icon"></i>
                            </span>
                            <div>
                                <div class="stateBox">
                                    <span class="name">{{ k.ApproverName }}</span>
                                    <span class="state">（{{ k.ParticipantAction }}）</span>
                                </div>
                                <span class="time">{{ k.EndTime }}</span>
                            </div>
                        </div>
                        <div
                            v-if="(k.Opinions||[]).length>0"
                            :class="{'opinions':true,'show-all':k.Opinions[0].showAll} "
                        >
                            <div class="opinion-text">
                                意见：{{ k.Opinions[0].opinion }}
                            </div>
                            <span class="iconfont iconshuangjiantouxia" @click="showOrHideOption(k.Opinions[0])"></span>
                        </div>
                        <ul>
                            <template v-for="(z, j) in k.CommentList">
                                <li :key="j">
                                    <!-- {{ z.Content }} -->
                                    <div class="icon">
                                        1
                                    </div>
                                    <div class="content">
                                        <div>{{ z.Content }}</div>
                                        <div>
                                            <span><i>*</i>{{ z.Content }}</span>
                                            <span><i>*</i>{{ z.Content }}</span>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'procurement-catalog',
    components: {},
    data() {
        return {
            // 审批动态数据
            dynamicData: [
                {
                    node_type: 2,
                    data: [
                        {
                            Content: '1111',
                            ApproverName: '2222',
                            ParticipantAction: '33333333',
                            EndTime: '4444',
                            Opinions: [
                                {
                                    showAll: true,
                                    opinion: '888888888',
                                },
                            ],
                            CommentList: [
                                {
                                    Content: '999999',
                                },
                                {
                                    Content: '999999',
                                },
                                {
                                    Content: '999999',
                                },
                                {
                                    Content: '999999',
                                },
                            ],
                        },
                    ],
                },
                {
                    node_type: 2,
                    data: [
                        {
                            Content: '1111',
                            ApproverName: '2222',
                            ParticipantAction: '33333333',
                            EndTime: '4444',
                            Opinions: [
                                {
                                    showAll: true,
                                    opinion: '888888888',
                                },
                            ],
                            CommentList: [
                                {
                                    Content: '999999',
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    },
    watch: {},
    created() {},
    mounted() {},
    computed: {},
    methods: {},
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus">
    .flowChartList
        width 100%
        height 100%
        overflow hidden
        overflow-y auto
        padding 20rpx
        .procedureList
            position relative
            padding-bottom 16rpx
            // &:last-child
            //     &:before
            //         display: none
            &:before
                content ''
                width 1px
                height 100%
                // background: url(./images/up.png) repeat-y
                background: #D7D7D7
                position absolute
                top 12rpx
                left 20rpx
            &.countersignatureNode
                &:after
                    content ''
                    width 1px
                    height calc(100% - 125rpx)
                    background: url(./images/up.png) repeat-y
                    position absolute
                    top 11rpx
                    left 50rpx
                .countersignatureTitle
                    display: flex
                    position: relative
                    z-index 9
                    color #FA6400
                    font-size: 16rpx
                    line-height: 24rpx
                    padding-left: 15rpx
                    margin-bottom: 20rpx
                    &:before
                        content ''
                        width 10rpx
                        height 1px
                        background: url(./images/across.png) repeat-x
                        position absolute
                        top 10rpx
                        left 41rpx
                    i
                        width 24rpx
                        height 24rpx
                        background: #FA6400
                        color #fff
                        text-align: center
                        line-height: 24rpx
                        font-size: 16rpx
                        border-radius: 50%
                        margin-right: 20rpx
                .listBox
                    padding-left: 70rpx
                    position: relative
                    h4
                        color #FA6400
                        position: relative
                        &:before
                            content ''
                            width 35rpx
                            height 1px
                            background: url(./images/across.png) repeat-x
                            position absolute
                            top 10rpx
                            left -39rpx
            .listBox
                h4
                    font-size 14rpx
                    line-height 16rpx
                    color #0285FE
                    padding-left 35rpx
                    background url('./images/decorate.png') no-repeat
                    background-size 12rpx 12rpx
                    background-position left center
                    margin-bottom: 10rpx
                    margin-left: 15rpx
                    display: flex
                    position: relative
                    z-index 9
                .userInfo
                    overflow hidden
                    display flex
                    span
                        display: inline-block
                        font-size 14rpx
                        line-height 20rpx
                        &.headPortrait
                            width 40rpx
                            height 40rpx
                            position relative
                            img
                                width 40rpx
                                height 40rpx
                            i
                                position absolute
                                bottom 0
                                right 0
                                width 15rpx
                                height 15rpx
                                background url('./images/pass.png') no-repeat
                                background-size 15rpx 15rpx
                        &.name
                            color #333333
                            margin-left 15rpx
                        &.state
                            color #2BC671
                        &.time
                            margin-left 15rpx
                            color #979EA7
                            font-size: 13rpx
                    div
                        width 100%
                    .stateBox
                        display flex
                        justify-content space-between
                .opinions
                    margin-top 6rpx
                    margin-left: 65rpx
                    background: #EEF7FF;
                    padding 6rpx 15rpx
                    position relative
                    overflow hidden
                    .opinion-text
                        display -webkit-box
                        font-size 14rpx
                        line-height 20rpx
                        color #155A9A
                        -webkit-box-orient vertical
                        -webkit-line-clamp 2
                        overflow hidden
                    &.show-all
                        .opinion-text
                            display flex
                        .iconshuangjiantouxia
                            transform rotate(180deg)
                    .iconshuangjiantouxia
                        position absolute
                        right 2rpx
                        top 28rpx
                        font-size 16rpx
                        color #0185FE
                ul
                    margin: 10rpx 0 0 65rpx
                    li
                        padding: 14rpx
                        border: 1px solid #F0F0F0
                        font-size: 14rpx
                        line-height: 20rpx
                        color #4A4A4A
                        display flex
                        background #FAFBFD;
                        .icon
                            width 20rpx
                        .content
                            flex 1
                            span
                                margin-right 10rpx
                                color #868FA3
                                i
                                    margin-right: 5rpx
                                    color #868FA3
                        &:last-child
                            margin-bottom: 0
</style>
